import { MeStoreType } from './types';
import { action } from 'easy-peasy';

// move to a feature or similar when we implement the api

export const meStore: MeStoreType = {
  orgType: 1,
  inviteCode: '',
  setInviteCode: action((state, payload) => {
    state.inviteCode = payload;
  }),
};
